"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var usePaginatedQuery_1 = require("./usePaginatedQuery");
Object.defineProperty(exports, "usePaginatedQuery", { enumerable: true, get: function () { return usePaginatedQuery_1.default; } });
//# sourceMappingURL=index.js.map